import React from "react";
import FormViewer from "../../components/FormViewer";
import LoaderButton from "../../components/LoaderButton";
import HttpServices from "../../utils/Http.services";
import { checkPermission, checkTranslation, translate } from "../../utils/useful";
// import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import moment from "jalali-moment";
import TLink from "../../components/TLink";
import i18n from "../../i18n";

class AdminSettingsApplet extends React.Component {


    state = {
        headers: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}Non-compliance title', required: true }, showMain: false, inExport: true },
            { col: '6', type: 'AdvancedSelectInput', key: 'action', showKey: 'actionTitle', information: { label: '{{lang}}Action type', address: 'getAllAtionsListWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: true }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'originnoncompliance', showKey: 'orgnoncompTitle', information: { label: '{{lang}}Non-compliance origin', address: 'getOriginOfNonComplianceWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: true }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'requirementTypes', showKey: 'requirTitle', information: { label: '{{lang}}Requirement type', address: 'getAllRequirementTypesWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: true }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'NonComplianceType', showKey: 'nonCompTypeTitle', information: { label: '{{lang}}Non-compliance type', address: 'getAllTypeOfNonComplianceWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: true }, showMain: false },
            // { col: '6', type: 'SelectInput', key: 'standard', showKey: 'standardTitle', information: { label: 'استاندارد', address: 'getAllStandards', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false }, showMain: false },
            { col: '6', type: 'AdvancedMultiTreeSelectAddListing', key: 'orgStandard', showKey: 'orgStandardTitle', information: { label: '{{lang}}Standard source', address: 'getAllStandardOriginWithoutPagination', parentAddress:'getAllStandards', parentFilter: {}, filter: {}, fields: { title: 'title', value: '_id', mainParent: 'standard',parent: 'parent' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: true }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'processes', showKey: 'processeTitle', information: { label: '{{lang}}Process', address: 'getAllProcessesWithoutPagination',  filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: true }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'department', showKey: 'departmentTitle', information: { label: '{{lang}}Department', address: 'getAllDepartment', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'product', showKey: 'productTitle', information: { label: '{{lang}}Product', address: 'getAllProductWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'equip', showKey: 'equipTitle', information: { label: '{{lang}}Equip', address: 'getAllEquipment', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'test', showKey: 'testTitle', information: { label: '{{lang}}Test', address: 'getAllTestWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'importnt', showKey: 'importntTitle', information: { label: '{{lang}}Importance degree', address: 'getAllImportantWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false }, showMain: false },
            { col: '6', type: 'AdvancedSelectInput', key: 'issueLocation', showKey: 'issueLocationTitle', information: { label: '{{lang}}Problem location', address: 'getAllLocationProblemWithoutPagination', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false }, showMain: false },

            { col: '12', key: 'requirementDescription', type: 'TextAreaInput', information: { label: '{{lang}}Requirement description', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '12', key: 'evidenceProblems', type: 'TextAreaInput', information: { label: '{{lang}}Forms and evidence', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '12', key: 'suggestionAndSolution', type: 'TextAreaInput', information: { label: '{{lang}}Suggestion and solution', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '12', key: 'attachment', type: 'FileInput', information: { label: '{{lang}}Attachment', single: false, cropper: true, ratio: '5:5', placeholder: '{{lang}}chooseImage' } },
            { col: '12', key: 'keyWords', type: 'TextInput', information: { label: '{{lang}}Key words', placeholder: '{{lang}}Use , to separate keywords', disabled: false }, showMain: true, inExport: true },
        ],
        fetched: false,
        actions: {
            submit: { key: "submit", label: "{{lang}}Submit", bgColor: '#F87C56', color: '#fff', function: this.submitForm, loader: "isPostingData" },
        },
        newsubmit: true

    }

    componentDidMount() {
        this.init()
    }

    init() {

    }

    submitForm = () => {

        this.postValue()

    }




    postValue = () => {
        if (this.form) {
            let data = this.form.getForm()
            this.setState({ errors: null })
            if (data) {
                this.setState({ isPostingData: true })
                if (this.state.data) {
                    data._id = this.state.data._id
                }
                HttpServices.request('postNonCompliance', data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    console.log(fetchError)
                    console.log('fetchResult0987', fetchResult)
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.setState({ data: fetchResult.info, newsubmit: false })
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}Sent Succesfully', description: '{{lang}}Send Record Succesfully' })


                })
            }
        }
    }

    changePage = (index, prop) => {
        this.setState({ activePage: index, hideModal: true }, () => {
            if (index == null) {
                this.setState({ hideModal: false, headers: this.props.headers })
            } else {
                this.setState({ hideModal: false, headers: this.props.page?.pages[index].headers })

            }
        })
    }

    itemAdded = () => { }

    itemEdited = () => { }


    render() {
        return (
            <div style={{}} className="container flexcc">
                <div className="mt-4" style={{ maxWidth: '750px' }}>
                    {this.state.newsubmit ? (
                        <div className="pb-5 w-100 h-100">

                            <div className="flexc  px-2">
                                <p className="text-small mld-4" style={{ color: '#00000050' }}>{translate('Last modified date')}: {moment(this.state.data?.uDate).locale(i18n.language).format('DD MMMM YYYY')}</p>
                            </div>
                            <p className="text-small mb-2  px-2" style={{ color: '#00000050' }}>{this.props.initData?._id}</p>


                            <div className="w-100 h-100" style={{ backgroundColor: '#f6f6f6', overflow: 'auto', borderRadius: 8 }}>
                                <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#143E74,#143E74)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>
                                    <div>
                                        <p className="white">{translate('Non-compliance registration')}</p>
                                    </div>
                                </div>
                                {this.props.page?.pages && (
                                    <div className="w-100 flexc mb-2">

                                        <div className="ml-0 text-center" onClick={() => { this.changePage(null) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.activePage == null ? '#F87C56' : '#F87C56b7fb7f', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                            <p>{translate('Details')}</p>
                                        </div>

                                        {this.props.page.pages.map((prop, index) => {
                                            return (
                                                <div className="ml-0 text-center" onClick={() => { this.changePage(index, prop) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', borderLeft: '1px solid #89a', transition: 'all 0.3s', backgroundColor: this.state.activePage == index ? (prop.tabColor ?? '#F87C56') : '#F87C56b7fb7f', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                                    <p>{checkTranslation(prop.title)}</p>
                                                </div>)
                                        })}
                                    </div>
                                )}

                                {!this.state.hideForm && (
                                    <div className="py-3 px-4">
                                        <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.state.data} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                                    </div>
                                )}


                                <div className="flexc px-3 pb-3">
                                    {Object.values(this.state.actions).map((prop, index) => {
                                        if (checkPermission(this.props.variables?.permissionRoot + '.edit') || checkPermission(this.props.variables?.permissionParentRoot + '.edit'))
                                            return (
                                                <div key={index} className="w-100 mx-1">

                                                    <LoaderButton
                                                        onClick={this.submitForm}
                                                        isLoading={this.props[prop.loader] ?? this.state[prop.loader]}
                                                        text={checkTranslation(prop.label)}
                                                        type={"Oval"}
                                                        className="text-bold text-small text-uppercase w-100"
                                                        buttonStyle={{ outline: 'none', width: '50%', backgroundColor: prop.bgColor, cursor: 'pointer', padding: '13px 20px', borderRadius: 8, textTransform: 'uppercase', fontSize: 15, fontWeight: 'bold', color: prop.color, border: 'none' }}
                                                        width={40}
                                                        height={40}
                                                        color={prop.bgColor}
                                                    />
                                                </div>
                                            )
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="flexcc" style={{ height: '83vh' }}>
                            <div className="p-4" style={{ backgroundColor: '#eee', borderRadius: '10px' }}>
                                <img style={{ width: '80px' }} src="/images/checkmark.svg" alt="" />
                                <p className="mb-4" style={{ fontSize: '20px' }}>{translate('Non-compliance successfully logged')}</p>
                                <p className="mb-1">{translate('Tracking Code')}</p>
                                <p className="modern-input flexc">{this.state.data?.trackingcode}</p>
                                <button onClick={() => this.setState({ newsubmit: true })} className="mt-3 py-2 px-4 mrd-2" style={{ background: '#143E74', color: 'white', borderRadius: '10px' }}>
                                    <p>{translate('New non-conformance register')}</p>
                                </button>
                                <TLink pathname={'/'}>
                                    <button onClick={() => this.setState({ newsubmit: true })} className="mt-3 py-2 px-4 mld-2" style={{ border: '1px solid #143E74', color: '#143E74', borderRadius: '10px' }}>
                                        <p>{translate('Return to home')}</p>
                                    </button>
                                </TLink>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        );

    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(AdminSettingsApplet);
